<template>
  <div id="divSelectPosWrapper">
    <VueForm
      v-if="isPhoneSelectionFlow && getUserPhones && getUserPhones.length"
      :bodyPadding="['0', '30']"
    >
      <VueButton
        class="pos-back"
        :iconName="getBackIcon.name"
        :iconSize="{ width: getBackIcon.width, height: getBackIcon.height }"
        iconColor="rgb(235, 56, 50)"
        :ghost="true"
        aria-label="Geri dön"
        @click.prevent="$router.go(-1)"
      />
      <VueText sizeLevel="11" weightLevel="3" class="header" color="grey-40">
        Telefon Seçiniz</VueText
      >
      <VueListView class="branch-list" dir="column">
        <div class="post-list-button" v-for="item in getUserPhones" :key="item.id">
          <VueButton
            :size="sizes.xLarge"
            :contentAlignment="constants.flexAlignment.center"
            :isSingleLine="false"
            outlined
            class="single-pos-item"
            :class="{ 'selected-pos': selectedPhone.id == item.id }"
            @click.prevent="setPhone(item)"
            >{{ item.phoneNumber }}</VueButton
          >
        </div>
      </VueListView>

      <div slot="footer" class="button-holder">
        <BrandButton
          class="submit-button"
          :size="sizes.xxLarge"
          :contentAlignment="constants.flexAlignment.center"
          type="submit"
          :disabled="!selectedPhone.id || isFetching"
          @click.prevent="submitPhone"
          >DEVAM ET</BrandButton
        >
      </div>
    </VueForm>

    <VueForm
      v-if="isPosSelectionFlow && getPosList && getPosList.length"
      :bodyPadding="['0', '30']"
    >
      <VueButton
        class="pos-back"
        :iconName="getBackIcon.name"
        :iconSize="{ width: getBackIcon.width, height: getBackIcon.height }"
        iconColor="rgb(235, 56, 50)"
        :ghost="true"
        aria-label="Geri dön"
        @click.prevent="$router.go(-1)"
      />
      <VueText sizeLevel="11" weightLevel="3" class="header-for-pos" color="grey-40">
        Şube Seçiniz</VueText
      >
      <VueListView class="branch-list" dir="column">
        <div class="post-list-button" v-for="item in getPosList" :key="item.id">
          <VueButton
            :size="sizes.xLarge"
            :contentAlignment="constants.flexAlignment.center"
            :isSingleLine="false"
            outlined
            class="single-pos-item"
            :class="{ 'selected-pos': selectedPos.id == item.id }"
            @click.prevent="setPos(item)"
            >{{ item.posName }}</VueButton
          >
        </div>
      </VueListView>

      <div slot="footer" class="button-holder">
        <BrandButton
          class="submit-button"
          :size="sizes.xxLarge"
          :contentAlignment="constants.flexAlignment.center"
          type="submit"
          :disabled="!selectedPos.id || isFetching"
          @click.prevent="submitPos"
          >DEVAM ET</BrandButton
        >
      </div>
    </VueForm>
  </div>
</template>
<script>
import VueListView from '@/components/shared/VueListView/VueListView.vue';
import VueButton from '@/components/shared/VueButton/VueButton.vue';
import BrandButton from '@/components/brand/BrandButton/BrandButton.vue';
import VueForm from '@/components/shared/VueForm/VueForm.vue';
import RoutesAthentication from '@/router/routes/RoutesAthentication.js';
import RoutesLogin from '@/router/routes/authentication/RoutesLogin.js';
import RoutesRoot from '@/router/routes/RoutesRoot.js';
import COMPONENT_CONSTANTS from '@/constants/component.constants.js';
import { ICON_VARIABLES } from '@/constants/component.constants.js';
import { FLEX_JUSTIFIES } from '@/constants/flex.constants.js';
import { mapGetters } from 'vuex';
import { Account, User } from '@/services/Api/index';
import StorageHelper from '@/utils/storageHelper';
import VueText from '@/components/shared/VueText/VueText.vue';
import AccountMixin from '@/utils/accountUtils.js';
import { setInsiderObject } from '@/utils/insiderUtils';
import { extractErrorMessage } from '../../../../../utils/errorExtractor';
import { UserTokenRoles } from '@/constants/userTokenRoles.js';

export default {
  name: 'SelectPhone',
  components: {
    VueButton,
    BrandButton,
    VueForm,
    VueListView,
    VueText,
  },
  mixins: [AccountMixin],
  data: () => {
    return {
      submitted: false,
      selectedPos: {},
      selectedPhone: {},
    };
  },
  props: {
    isChangePos: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    if (!this.$store.state.auth.userPhones && !this.$store.state.auth.posList) {
      this.$router.push(RoutesLogin.SelectLoginType.path);
      return;
    }

    this.$nextTick(() => {
      if (this.isPhoneSelectionFlow) {
        return;
      }

      if (this.isPosSelectionFlow) {
        this.getPosList.forEach(f => {
          if (f.isCurrentPos) {
            this.selectedPos = f;
          }
        });
        return;
      }

      this.$router.push(RoutesLogin.SelectLoginType.path);
    });
  },
  computed: {
    ...mapGetters('auth', ['getPosList', 'getUserPhones']),
    ...mapGetters('app', ['getChangedPosToken']),
    ...mapGetters('auth', { isFetching: 'getLoginFetching' }),
    isPhoneSelectionFlow() {
      return (this.getUserPhones?.length ?? 0) > 0;
    },
    isPosSelectionFlow() {
      return !this.isPhoneSelectionFlow && (this.getPosList?.length ?? 0) > 0;
    },
    constants() {
      return {
        flexAlignment: FLEX_JUSTIFIES,
      };
    },
    sizes() {
      return COMPONENT_CONSTANTS.COMPONENT_SIZES;
    },
    routes() {
      return {
        auth: RoutesAthentication,
      };
    },
    getIcon() {
      return ICON_VARIABLES.eye;
    },
    getBackIcon() {
      return ICON_VARIABLES.arrowLeft;
    },
  },
  methods: {
    setPos(item) {
      this.selectedPos = item;
    },
    setPhone(item) {
      this.selectedPhone = item;
    },
    async submitPos() {
      if (this.selectedPos.id) {
        try {
          this.$store.dispatch('auth/setLoginFetching', true);
          new StorageHelper({ id: process.env.VUE_APP_STORAGE_CURRENT_POS_KEY }).set(
            this.selectedPos,
          );
          await this.$store.dispatch('auth/setSelectedPos', this.selectedPos);
          await this.updateUserDetailsAfterPosChange();
          this.accountLogin(this.selectedPos.posChannel, null, null);
        } catch (error) {
          this.$store.dispatch('auth/setLoginError', error);
          const errModalConfig = {
            isModalOpened: true,
            modalText: extractErrorMessage(error),
          };
          this.$store.dispatch('app/setErrorModalConfig', errModalConfig);
        } finally {
          this.$store.dispatch('auth/setLoginFetching', false);
        }
      }
    },
    async updateUserDetailsAfterPosChange() {
      try {
        const res = await User.getUserDetail();
        if (res && res.data.Data && res.data.Data.userDetail) {
          const userDetails = res.data.Data.userDetail;
          const cookieSettings = res.data.Data.cookieSettings;

          new StorageHelper({
            id: process.env.VUE_APP_STORAGE_CURRENT_USER_DETAIL,
          }).set(userDetails);
          new StorageHelper({
            id: process.env.VUE_APP_STORAGE_CURRENT_USER_COOKIE_SETTINGS,
          }).set(cookieSettings);

          await this.$store.dispatch('auth/setUserDetails', userDetails);
          await this.$store.dispatch('app/setCookieSettings', cookieSettings);

          setInsiderObject(userDetails);
        }
      } catch (error) {
        console.error('Error updating user details after POS change:', error);
      }
    },
    async submitPhone() {
      if (this.selectedPhone.id) {
        try {
          this.$store.dispatch('auth/setLoginFetching', true);
          const selectedUserRes = await Account.selecteduser(this.selectedPhone.id);
          const { Data } = selectedUserRes ? selectedUserRes.data : { Data: null };
          if (!Data) {
            return;
          }

          if (
            Data.tokenRole === UserTokenRoles.VerifyMFA ||
            Data.tokenRole === UserTokenRoles.RegisterMFA
          ) {
            if (Data.token) {
              const currentToken = new StorageHelper({
                id: process.env.VUE_APP_STORAGE_TOKEN_KEY,
              }).get();
              new StorageHelper({ id: process.env.VUE_APP_STORAGE_PRE_MFA_TOKEN }).set(
                currentToken,
              );

              new StorageHelper({ id: process.env.VUE_APP_STORAGE_TOKEN_KEY }).set(Data.token);
            }
            const phone = (Data.user && Data.user.phoneNumber) || '';
            const last4 = String(phone)
              .replace(/\D/g, '')
              .slice(-4);
            this.$router.push({
              path: `${RoutesRoot.Authentication.path}/${RoutesAthentication.Login.path}/${RoutesLogin.LoginMfaVerification.path}`,
              query: {
                mfaRole: Data.tokenRole,
                maskedPhone: last4,
                mfaOrigin: RoutesLogin.SelectPhone.name,
              },
            });
            return;
          }

          const { token, user, refreshToken, selectedPos, staffValidation } = Data;

          await this.$store.dispatch('auth/setAuthData', Data);

          if (token) {
            new StorageHelper({ id: process.env.VUE_APP_STORAGE_TOKEN_KEY }).set(token);
          }
          if (user) {
            new StorageHelper({ id: process.env.VUE_APP_STORAGE_CURRENT_USER_KEY }).set(user);
          }
          if (refreshToken) {
            new StorageHelper({ id: process.env.VUE_APP_STORAGE_REFRESH_TOKEN_KEY }).set(
              refreshToken.token,
            );
          }

          if (selectedPos && Array.isArray(selectedPos) && selectedPos.length > 1) {
            await this.$store.dispatch('auth/setPosList', selectedPos);
            this.$router.push(
              `${RoutesRoot.Authentication.path}/${RoutesAthentication.Login.path}/${RoutesLogin.SelectPos.path}`,
            );
          } else if (selectedPos) {
            new StorageHelper({ id: process.env.VUE_APP_STORAGE_CURRENT_POS_KEY }).set(
              Array.isArray(selectedPos) ? selectedPos[0] : selectedPos,
            );
            this.accountLogin(
              (Array.isArray(selectedPos) ? selectedPos[0] : selectedPos).posChannel,
              staffValidation,
              user,
            );
          }
        } catch (error) {
          this.$store.dispatch('auth/setLoginError', error);
          const errModalConfig = {
            isModalOpened: true,
            modalText: extractErrorMessage(error),
          };
          this.$store.dispatch('app/setErrorModalConfig', errModalConfig);
        } finally {
          this.$store.dispatch('auth/setLoginFetching', false);
        }
      }
    },
  },
};
</script>
<style scoped lang="scss">
.header {
  padding-top: palette-space-level('60');
  padding-bottom: palette-space-level('10');
}

.header-for-pos {
  padding-top: palette-space-level('20');
  padding-bottom: palette-space-level('10');
}

.post-list-button {
  padding-top: palette-space-level('20');
}

.button-holder {
  padding-top: palette-space-level('40');

  .submit-button {
    border-radius: palette-radius-level('2');
  }
}

.selected-pos {
  background-color: palette-color-level('green', 30) !important;
  color: palette-color-level('white', 100) !important;
}

.single-pos-item {
  overflow: hidden;
  text-overflow: ellipsis !important;
}

.branch-list {
  height: 450px;
  overflow-y: auto;
  padding-right: palette-space-level('10');
  box-shadow: 0 2px 0 0 rgba(0, 0, 0, 0.05);

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    width: 8px;
    border-radius: 5.5px;
    background-color: palette-color('grey-10');
  }

  &::-webkit-scrollbar-thumb {
    width: 8px;
    border-radius: 5.5px;
    background-color: palette-color('grey-40');
  }
}

.pos-back {
  display: block;
  width: auto;
  margin: 0 0 12px;
}
</style>
